export default __webpack_public_path__ + "static/Loreal_ContentPro_banner-a6b50948b8fcf74110e47263747dcc0c.jpg";